<template>
    <div>        
        <list :label="$t('files')" v-bind:refresh="this.refresh" table='files' v-bind:hideExport="true" v-bind:showDownload="true" v-on:childMessage="onMessageFromListReceived" initialSortBy="name" :initialSortDesc="true"></list>
        <v-dialog v-bind:value="showDialog" v-bind:persistent="true" max-width="600">
            <v-card>
                <v-card-title>
                    Datei hochladen
                </v-card-title>
                <v-card-text>
                    <v-file-input show-size v-model=file :label="$t('select file')"/>
                    <v-select v-model="folder" :label="$t('type')" :items=getFolders()></v-select>
                    <v-checkbox v-model="overwrite" :label="$t('overwrite file')"></v-checkbox>
                    <v-select v-if="isAdmin()" v-model="customerId" :label="$t('customer')" :items=getCustomers() item-text="customername" item-value="id"></v-select>
                    <v-chip outlined color="primary" v-if='this.text!=""'>
                        {{text}}
                    </v-chip>
                </v-card-text>
                <v-card-actions>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=submitFile><v-icon dense left>mdi-cloud-upload-outline</v-icon>{{$t('upload')}}</v-btn>
                    <v-btn elevation="20" class="white--text" color="#49a5ac" @click=cancel()><v-icon dense left>mdi-cancel</v-icon>{{$t('cancel')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import List from "@/components/List"
import Api from "@/Api";
import { Utils } from "@/Utils"

export default {
    components:
    {
        List
    },

    data()
    {
        return {
            file: null,
            refresh: 0,
            showDialog: "",
            text: "",
            customerId: "",
            folder: "Allgemein",
            overwrite: false
        }
    },

    mixins: [Utils],

    methods:
    {
        onMessageFromListReceived (message)
        {
            if (message.cmd === "newRecord")
                this.showDialog = true;
            else if (message.cmd === "updRecord")
            {
                const file = message.item["name"];
                const t = message.item["type"];
                const fileCustomer = message.item["customer"]
                let customerId = null;
                if (this.isAdmin())
                {                    
                    customerId = (fileCustomer == "intern" ? fileCustomer : this.getCustomerId(message.item["customer"]));                 
                }

                const self = this;                
                Api.downloadFile(file, t, customerId)
                .then(function(response)
                {
                    const ticket = response.data.ticket;
                    Api.downloadTicket(ticket);
                })
                .catch(function(e)
                {
                    alert(self.$t("download not possible"));
                });
            }
            else if (message.cmd === "delRecord")
            {
                const self = this;
                const file = message.item["name"];
                const t = message.item["type"];
                const fileCustomer = message.item["customer"]
                let customerId = null;
                if (this.isAdmin())
                {                    
                    customerId = (fileCustomer == "intern" ? fileCustomer : this.getCustomerId(message.item["customer"]));                 
                }
                
                Api.deleteFile(file, t, customerId)
                .then(function(response)
                {                    
                    self.refresh++;
                })
                .catch(function(e)
                {
                    alert(self.$t("could not delete file"));
                });
            }
        },

        submitFile()
        {
            if (!this.file)
            {
                this.text = this.$t("select file");
                return;
            }
            const self = this;
            this.text = "";
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('folder', this.folder);
            formData.append('overwrite', this.overwrite);
            if (this.isAdmin())
                formData.append('customerId', this.customerId)

            Api.uploadFile(formData)
            .then(function()
            {
                self.refresh++;
                self.cancel();
            })
            .catch(function(e)
            {
                if (e.response.status === 409)
                    self.text = self.$t("already exists");
                else
                    self.text = self.$t("action not possible");
            });
        },

        cancel()
        {
            this.text = "";
            this.showDialog = "";
            this.file = null;
        }
    }
}
</script>